import { Navigate } from 'react-router-dom';
import { useUserContext } from '../contexts/UserContext';
import Loader from '../components/Loader';

export default function DashboardLanding() {
  const { user, selectedVenueData, venueDataLoading } = useUserContext();

  // Not logged in – just in case this is ever hit without AuthGuard
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  // Superadmin: go to customer services dashboard
  if (user.isSuperAdmin) {
    return <Navigate to="/customer-services/dashboard" replace />;
  }

  // Wait for venue data to finish loading before deciding where to redirect
  if (venueDataLoading) {
    return <Loader />;
  }

  // Venue admin with a selected venue: go to that venue dashboard
  if (selectedVenueData?.orgID) {
    return <Navigate to={`/dashboard/venue/${selectedVenueData.orgID}`} replace />;
  }

  // Fallback: user settings (or whatever you want as default)
  return <Navigate to="/dashboard/settings" replace />;
}
